export const wrapper = {
  backgroundColor: 'grey-05',
  display: 'flex',
  flexDirection: ['column', 'row'],
  justifyContent: ['unset', 'space-between'],
  mb: ['lg', 'xxl']
}

export const content = {
  maxCharacters: 500,
  width: '100%',
  flex: 1,
  mr: [0, 120],
  whiteSpace: 'pre-wrap',
  fontSize: 'md',
  lineHeight: 'sm',
  mb: 0,
  p: {
    fontSize: 'md',
    lineHeight: 'sm'
  }
}

export const h3 = {
  fontSize: ['md', 'xl'],
  fontWeight: 'xxbold',
  a: {
    borderBottom: 'none',
    fontWeight: 'inherit'
  }
}

export const imageWrapper = {
  width: ['100%', '50%'],
  height: 'auto',
  flex: 1,
  overflow: 'hidden'
}

export const image = {
  objectFit: ['contain', 'cover'],
  width: '100%',
  height: '100%'
}

export const link = {
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  gridGap: 'xxs',
  alignItems: 'center',
  mt: ['xxl', 'auto'],
  mb: 0,
  textDecoration: 'none',
  width: 'fit-content',
  borderBottom: '1px dashed',
  borderBottomColor: 'grey-50'
}

export const date = {}
export const tag = {}
export const superScript = {}
export const contentChildren = {}
export const heading = {}
export const description = {
  fontSize: '16px !important',
  my: 'md',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: ['3', '2'],
  WebkitBoxOrient: 'vertical'
}

export const authorWrapper = {
  display: 'flex'
}

export const authorName = {
  fontSize: 'xxs',
  a: { borderBottom: 'none' },
  display: 'block'
}

export const authorImage = {
  borderRadius: '50%'
}
